import { call, fork, put, take, cancel, cancelled } from 'redux-saga/effects'
import { getFirebase } from 'react-redux-firebase'

import { types as userActionTypes, actions as userActions } from '../user/user.reducer'

// firebase - login with email and password
export const loginWithEmailAndPassword = ({ email, password }) => {
    const fb = getFirebase()
    return fb.auth().signInWithEmailAndPassword(email, password)
}

// watch / detect auto logout (delete app data, user disabled, session expired)
export function* watchAutoLogout() {
    while (true) {
        yield take(userActionTypes.AUTHENTICATED_NO)
        console.warn(
            'TODO: move user to home if the router is on a path that requires authentication, or check if routes will properly handle this case'
        )
    }
}

// attempt to login
export function* processLoginWithUserAndPassword(credentials) {
    try {
        yield call(loginWithEmailAndPassword, credentials)
        yield put(userActions.loginSuccess())
    } catch (e) {
        yield put(userActions.loginFailedWEP(e))
    } finally {
        if (yield cancelled()) {
            console.warn('WARN: Login process cancelled')
        }
    }
}

// watch user manual login
export function* watchLogin() {
    while (true) {
        // capture the login attempt using email and password
        const { credentials } = yield take(userActionTypes.LOGIN_ATTEMPT_WEP)
        // spawn an async task that will try to log in
        const attemptTask = yield fork(processLoginWithUserAndPassword, credentials)
        // capture an eventual logout or an error raised from the login attempt
        const action = yield take([
            userActionTypes.LOGIN_FAILED_WEP,
            userActionTypes.LOGOUT,
            userActionTypes.AUTHENTICATED_NO,
        ])
        switch (action.type) {
            // if is a logout should cancel a previous attempt  to log in
            case userActionTypes.LOGOUT:
                yield cancel(attemptTask)
                break
            default:
                break
        }
    }
}
